import React from 'react';
const CHECKOUT_URL = 'https://betterdailyguides.com/cart/51925795668270:1';
interface HeroSectionProps {
  onBuyClick: (e: React.MouseEvent) => void;
}
export function HeroSection({
  onBuyClick
}: HeroSectionProps) {
  return <section className="bg-gradient-to-br from-[#FAF7F2] via-[#F0E8DE] to-[#E8DDD0] min-h-screen flex items-center py-24 px-5 relative overflow-hidden" data-id="element-109">
      {/* Blurred background image */}
      <div className="absolute inset-0 z-0" data-id="element-110">
        <img src="https://cdn.magicpatterns.com/uploads/fxZyJxXuMXa1GdwMFThAnu/Imagen_16_9_vertical.png" alt="" className="w-full h-full object-cover blur-2xl scale-110 opacity-30" data-id="element-111" />
        <div className="absolute inset-0 bg-gradient-to-br from-[#FAF7F2]/70 via-[#F0E8DE]/60 to-[#E8DDD0]/70 shadow-inner" data-id="element-112" />
      </div>

      <div className="absolute top-[-50%] right-[-20%] w-[600px] h-[600px] rounded-full bg-gradient-radial from-[rgba(183,110,121,0.08)] to-transparent pointer-events-none z-[1]" data-id="element-113" />

      <div className="max-w-[1100px] mx-auto grid md:grid-cols-2 gap-16 items-center w-full relative z-[2]" data-id="element-114">
        {/* Right side (image) - shows first on mobile */}
        <div className="relative order-first md:order-last flex flex-col gap-8" data-id="element-115">
          <div className="relative" data-id="element-116">
            <div className="rounded-3xl overflow-hidden shadow-2xl" data-id="element-117">
              <img src="https://cdn.magicpatterns.com/uploads/qZGEuuFcix5Fu8Cb8VPK1A/foto_website_1.png" alt="B.A.B.Y. 365 Protocol — Your Baby's First Year" className="w-full object-cover" data-id="element-118" />
            </div>
            <div className="hidden md:block absolute bottom-[-15px] left-[-15px] bg-white rounded-xl p-3 shadow-xl font-sans text-center border-l-4 border-[#B76E79]" data-id="element-119">
              <strong className="block text-2xl text-[#B76E79]" data-id="element-120">+2,400</strong>
              <span className="text-[11px] text-gray-400" data-id="element-121">
                Families already applying it
              </span>
            </div>
          </div>
        </div>

        {/* Left side (content) */}
        <div className="text-center md:text-left" data-id="element-122">
          <span className="inline-block bg-gradient-to-r from-[#B76E79] to-[#8B4A52] text-white text-[11px] tracking-widest uppercase px-4 py-1.5 rounded-full mb-5 font-sans font-bold" data-id="element-123">
            ⭐ B.A.B.Y. 365 Protocol — 2026 Edition
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-6xl text-[#3D2B1F] leading-tight mb-4 font-bold" data-id="element-124">
            Your Baby's <span className="text-[#B76E79]" data-id="element-125">First Year</span> Is
            The Most Important.
            <br data-id="element-126" />
            Did You Know That?
          </h1>

          <p className="text-lg md:text-xl text-[#6B4C3B] mb-8 italic leading-relaxed" data-id="element-127">
            The first infant neuro-architecture protocol that unifies sleep,
            cognitive stimulation, and nutrition in a single system. For parents
            who don't raise by accident.
          </p>

          <ul className="list-none mb-9 space-y-3.5 text-left" data-id="element-128">
            {['Your baby sleeping 8 hours in record time', '52 scientific activities to skyrocket their IQ', 'The nutritional guide that eliminates picky eating forever', 'Immediate access + 4 Bonuses valued at $138'].map((item, idx) => <li key={idx} className="flex items-start gap-3 text-base text-[#3D2B1F] font-sans" data-id="element-129">
                <span className="flex items-center justify-center w-5 h-5 rounded-full bg-[#B76E79] text-white text-xs font-bold flex-shrink-0 mt-0.5" data-id="element-130">
                  ✓
                </span>
                {item}
              </li>)}
          </ul>

          <div className="bg-white rounded-2xl p-6 shadow-lg border-2 border-[rgba(183,110,121,0.2)] mb-6" data-id="element-131">
            <div className="text-xs tracking-widest uppercase text-[#B76E79] font-sans font-bold mb-2" data-id="element-132">
              🔒 Immediate Digital Download
            </div>
            <div className="text-lg text-gray-400 line-through font-sans mb-1" data-id="element-133">
              Total value: $235
            </div>
            <div className="text-5xl md:text-6xl text-[#3D2B1F] font-bold leading-none mb-1.5" data-id="element-134">
              $12.97
            </div>
            <span className="inline-block bg-green-50 text-green-700 text-[13px] font-bold px-3 py-1 rounded-full font-sans" data-id="element-135">
              💰 You save $222.03 today (95% OFF)
            </span>
            <p className="mt-3 text-xs text-[#6B4C3B] font-sans italic leading-relaxed" data-id="element-136">
              Why only $12.97? Because it's a digital product and we have no
              printing or shipping costs. We pass those savings on to you.
            </p>
          </div>

          <a href={CHECKOUT_URL} onClick={onBuyClick} className="block w-full bg-gradient-to-r from-[#B76E79] to-[#8B4A52] text-white text-lg font-bold py-4 px-8 rounded-full text-center tracking-wide shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 font-sans uppercase mb-3 animate-cta-pulse" data-id="element-137">
            ⚡ YES, I WANT IMMEDIATE ACCESS FOR $12.97 →
          </a>

          <div className="flex gap-5 flex-wrap text-xs text-gray-400 font-sans justify-center md:justify-start" data-id="element-138">
            <span className="flex items-center gap-1.5" data-id="element-139">
              🔒 100% Secure Payment
            </span>
            <span className="flex items-center gap-1.5" data-id="element-140">
              🚫 No Hidden Subscriptions
            </span>
            <span className="flex items-center gap-1.5" data-id="element-141">
              📥 Immediate Download
            </span>
            <span className="flex items-center gap-1.5" data-id="element-142">
              ↩️ 30-Day Guarantee
            </span>
            <span className="flex items-center gap-1.5" data-id="element-143">
              💳 Visa · PayPal · Mastercard
            </span>
          </div>
        </div>
      </div>
    </section>;
}